import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-582eb67f")

_pushScopeId("data-v-582eb67f")
const _hoisted_1 = { style: {"background":"#FFFFFF","padding":"20px"} }
const _hoisted_2 = { style: {"color":"#FF7209","white-space":"nowrap"} }
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = {
  key: 0,
  style: {"display":"flex","flex":"1","align-items":"center"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { style: {"margin":"0 10px","vertical-align":"center"} }, " - ", -1)
const _hoisted_6 = {
  key: 1,
  style: {"color":"#ff0000"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_8 = { class: "line-height30px" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "height20px" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_pin_encrypt_input = _resolveComponent("pin-encrypt-input")
  const _component_choose_face_dialog = _resolveComponent("choose-face-dialog")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_access_group_mode = _resolveComponent("access-group-mode")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "set-page-form-width",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextName,
            prop: "Name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.type==='deliveryAuth')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.ProperAllTextPIN,
                prop: "PinCode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_pin_encrypt_input, {
                    modelValue: _ctx.formData.PinCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.PinCode = $event)),
                    option: _ctx.option
                  }, null, 8, ["modelValue", "option"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.DeliveryRfCard,
            prop: "CardCode"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.CardCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.CardCode = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.type==='staffAuth')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _ctx.$wordList.ProperAllTextFaceID,
                prop: "Face"
              }, {
                default: _withId(() => [
                  _createVNode(_component_choose_face_dialog, {
                    isShowEditImage: _ctx.formData.HaveFace,
                    onChange: _ctx.chooseFile,
                    onRemove: _ctx.removeFile
                  }, null, 8, ["isShowEditImage", "onChange", "onRemove"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.projectType==='community')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                style: _ctx.buildOptions.length===1?'':'width: 700px',
                label: _ctx.$wordList.AccessibleFloors
              }, {
                default: _withId(() => [
                  _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.PleaseAccessibleBuildings), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floors, (floor, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "floors-item"
                    }, [
                      _createVNode("div", _hoisted_3, [
                        (_ctx.buildOptions.length>1)
                          ? (_openBlock(), _createBlock("div", _hoisted_4, [
                              _createVNode(_component_cus_select, {
                                style: {"width":"100%"},
                                modelValue: _ctx.floors[index].build,
                                "onUpdate:modelValue": ($event: any) => (_ctx.floors[index].build = $event)
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_cus_option, {
                                    value: "",
                                    label: ""
                                  }),
                                  (index === 0)
                                    ? (_openBlock(), _createBlock(_component_cus_option, {
                                        key: 0,
                                        value: "all",
                                        label: _ctx.$wordList.AllBuildings
                                      }, null, 8, ["label"]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_cus_option, {
                                      key: item.key,
                                      label: item.value,
                                      value: item.key,
                                      disabled: _ctx.floors.findIndex(f=> f.build===item.key)!==-1
                                    }, null, 8, ["label", "value", "disabled"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                              _hoisted_5
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_cus_select, {
                          style: {"flex":"1","height":"100% !important"},
                          multiple: "",
                          disabled: (_ctx.floors[index].build==='' && _ctx.buildOptions.length>1) || _ctx.buildOptions.length===0,
                          onChange: ($event: any) => (_ctx.changeFloor($event,index)),
                          modelValue: _ctx.floors[index].floor,
                          "onUpdate:modelValue": ($event: any) => (_ctx.floors[index].floor = $event)
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_cus_option, {
                                key: item.key,
                                label: item.value,
                                value: item.key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                      ]),
                      ((index!==0))
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            class: "delete-icon el-icon-my-remove margin-left15px",
                            onClick: ($event: any) => (_ctx.removeFloors(index))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.floors[index].isShowNotice)
                        ? (_openBlock(), _createBlock("label", _hoisted_6, _toDisplayString(_ctx.$wordList.PleaseSelectFloorLeast), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.buildOptions.length>1 && !(_ctx.floors.findIndex(f=>f.build==='all')!==-1))
                    ? (_openBlock(), _createBlock(_component_cus_button, {
                        key: 0,
                        onClick: _ctx.addFloors
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ListInHtmlAdd), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["style", "label"]))
            : _createCommentVNode("", true),
          (_ctx.projectType==='office')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: _ctx.$wordList.AccessibleFloors
              }, {
                default: _withId(() => [
                  (_ctx.floors.length > 0)
                    ? (_openBlock(), _createBlock(_component_cus_select, {
                        key: 0,
                        style: {"width":"100%"},
                        multiple: "",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeFloor($event,0))),
                        modelValue: _ctx.floors[0].floor,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.floors[0].floor = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_cus_option, {
                              key: item.key,
                              label: item.value,
                              value: item.key
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"]),
      _hoisted_7,
      _createVNode(_component_access_group_mode, {
        "select-item": _ctx.selectItem,
        onWatchSelectValue: _ctx.getSelectValue
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_8, [
            _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextAccessGroup), 1)
          ])
        ]),
        _: 1
      }, 8, ["select-item", "onWatchSelectValue"]),
      _hoisted_9,
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})